"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeSystem = void 0;
const gotti_1 = require("gotti");
const Tree_1 = require("../../Assemblages/Tree");
const Constants_1 = require("../../../Shared/Constants");
class TreeSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.TREE);
        this.addedTrees = false;
        this.treeSeq = 0;
        this.treeColliders = [];
        this.trees = [];
        this.currentChoppingTrees = [];
        this.inPlayerRangeTrees = [];
        this.treeChopCollisionPlugin = {
            name: 'tree_chop',
            type: 'collision',
            tagAs: [Constants_1.COLLIDER_TAGS.tree_stump],
            tagBs: [Constants_1.COLLIDER_TAGS.client_player],
            onCollisionStart: (treeCollider, clientCollider) => {
                if (!treeCollider.data.entity)
                    throw new Error(`Expected an entity object in treeCollider.data`);
                const tree = treeCollider.data.entity;
                if (this.inPlayerRangeTrees.includes(tree))
                    throw new Error(`Already included.`);
                this.inPlayerRangeTrees.push(tree);
            },
            onCollisionEnd: (treeCollider, clientCollider) => {
                if (!treeCollider.data.entity)
                    throw new Error(`Expected an entity object in treeCollider.data`);
                const tree = treeCollider.data.entity;
                if (!this.inPlayerRangeTrees.includes(tree))
                    throw new Error(`Should have been included.`);
                this.inPlayerRangeTrees = this.inPlayerRangeTrees.filter(t => t !== tree);
            },
        };
    }
    onClear() {
    }
    onInit() {
        this.globals.tileWorld.use(this.treeChopCollisionPlugin);
    }
    onStart() {
        this.spawnInitialTrees(this.globals.gameStateData);
        this.globals.tileWorld.onBeforeMapDestroyed(mapName => {
            if (mapName === 'island') {
                [...this.trees].forEach(t => {
                    this.destroyEntity(t);
                });
            }
        });
        this.globals.tileWorld.onMapCreated(mapName => {
            if (mapName === 'island' && !this.trees.length) {
                this.spawnInitialTrees(this.globals.clientPlayer.gameState);
            }
        });
    }
    spawnInitialTrees(gameData) {
        // //console.error('spawn initial trees. loaded map was', this.globals.tileWorld.loadedMap);
        if (this.globals.tileWorld.currentMap === 'island') {
            const islandStateData = gameData.levels.find(l => l.name === 'island');
            islandStateData.state.items.forEach(i => {
                if (i.name === 'tree') {
                    const tree = new Tree_1.Tree(i.uid);
                    this.initializeEntity(tree, { position: { x: i.x, y: i.y } });
                }
            });
        }
    }
    onLocalMessage(message) {
    }
    onPeerMessage(peerId, message) {
    }
    onEntityAddedComponent(entity, component) {
        this.trees.push(entity);
        const texture = this.globals.gameTextures.items.placed.tree;
        const p = entity.getComponent(Constants_1.SYSTEMS.POSITION).getPosition();
        entity.gameObject = this.globals.tileWorld.addGameObject({
            position: p,
            texture,
            layer: 1,
            colliders: [{
                    dynamic: false,
                    layer: 1,
                    shapeData: { x: texture.width / 2 - 8, y: texture.height - 20, w: 16, h: 20 },
                    tags: ['tree_stump', 'blocking']
                }]
        });
        const col = entity.gameObject.colliders[0];
        entity.gameObject.entity = entity;
        col.data = col.data || {};
        col.data.entity = entity;
    }
    onEntityRemovedComponent(entity, component) {
        var _a;
        if (entity.gameObject) {
            (_a = entity.gameObject.colliders) === null || _a === void 0 ? void 0 : _a.forEach(c => {
                if (c.data)
                    delete c.data.entity;
            });
            entity.gameObject.removeFromMap();
            delete entity.gameObject.entity;
        }
        this.trees = this.trees.filter(t => t !== entity);
    }
    onServerMessage(message) {
    }
    update(delta) {
    }
}
exports.TreeSystem = TreeSystem;
//# sourceMappingURL=module.js.map